<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="filterStatusOrder(orders)"
    :search="search"
    sort-by="issuance_date"
    :sort-desc="true"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>PEDIDOS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-select
            :items="listStatus"
            v-model="filter_status"
            label="Status"
            outlined
            dense
            multiple
            hide-details
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                color="green darken-2"
                class="white--text"
                label
                small
                v-if="index === 0"
              >
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                (+{{ filter_status.length - 1 }})
              </span>
            </template>
          </v-select>
        </v-col>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-toolbar color="red lighten-1" dark class="text-h5"
              >Atenção</v-toolbar
            >
            <v-card-title class="text-h6">
              Tem certeza que deseja Deletar?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Fechar</v-btn
              >
              <v-btn color="red darken-1" dark @click="deleteItemConfirm">
                <v-icon dark>mdi-delete</v-icon>
                Deletar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogStatus" max-width="850px" min-height="450px">
          <v-card>
            <v-toolbar color="blue lighten-1" dark class="text-h5"
              >Gerenciar Pedido</v-toolbar
            >
            <v-card-text>
              <v-row class="mt-6">
                <v-col cols="12" xs="12" md="4"
                  >Pedido:
                  <b
                    >{{ editedItem.franchise.code }} - {{ editedItem.code }}</b
                  ></v-col
                >
                <v-col cols="12" xs="12" md="8"
                  >Franqueado:
                  <b
                    >{{ editedItem.franchise.code }} -
                    {{ editedItem.franchise.name }}</b
                  ></v-col
                >
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="4"
                  >Data:
                  <b>{{ editedItem.issuance_date | dateFormatBr }}</b></v-col
                >
                <v-col cols="12" xs="12" md="8"
                  >Valor:
                  <b>{{
                    getValueWithDiscount(editedItem) | currencyEuaToBr
                  }}</b></v-col
                >
              </v-row>
              <v-row>
                <v-col>
                  <v-radio-group
                    v-model="editedItem.status"
                    column
                    class="mt-0"
                  >
                    <v-radio
                      v-if="editedItem.status === 'validated_franchisor'"
                      label="Pedido Aguardando Confirmação"
                      value="validated_franchisor"
                    ></v-radio>
                    <label class="mb-4">Situação do Pedido</label>
                    <v-radio
                      label="Pedido Confirmado"
                      value="confirmed_supplier"
                    ></v-radio>
                    <v-radio
                      label="Pedido Recusado"
                      value="refused_supplier"
                    ></v-radio>
                    <v-radio
                      label="Pedido Faturado"
                      value="invoiced_supplier"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col>
                  <v-card
                    outlined
                    elevation="2"
                    v-if="editedItem.status === 'invoiced_supplier'"
                  >
                    <v-container>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            class="text-field-uppercase"
                            label="Número da Nota"
                            v-model="editedItem.number_note"
                            dense
                            hide-details
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field-money
                            v-model="editedItem.value_note"
                            label="Valor da Nota"
                            v-bind:properties="{
                              prefix: 'R$',
                              readonly: false,
                              dense: true,
                              outlined: true,
                              clearable: false,
                              hideDetails: true,
                              placeholder: ' ',
                            }"
                            v-bind:options="{
                              locale: 'pt-BR',
                              length: 11,
                              precision: 2,
                              empty: null,
                            }"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-file-input
                            label="Anexar Nota Fiscal"
                            outlined
                            dense
                            hide-details
                            @change="onFilePicked"
                            accept=""
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <!-- <v-card
                    outlined
                    elevation="2"
                    v-if="editedItem.status === 'refused_supplier'"
                  >
                    <v-container> -->
                  <v-row v-if="editedItem.status === 'refused_supplier'">
                    <v-col cols="12">
                      <v-textarea
                        name="intput-7-1"
                        label="Motivo da recusa"
                        class="text-field-uppercase"
                        dense
                        :height="140"
                        hide-details
                        outlined
                        no-resize
                        :value="editedItem.reason_refused"
                        @input="(value) => (editedItem.reason_refused = value)"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <!-- </v-container>
                  </v-card> -->
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray darken-1" text @click="closeDialogStatus()"
                >Fechar</v-btn
              >
              <v-btn color="blue darken-1" dark @click="saveOrderStatus()">
                <v-icon dark>mdi-send</v-icon>
                Salvar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <alert
        :visible="!!showAlert"
        dark
        :type="typeAlert"
        :message="alertMessage"
        :clickClose="() => (showAlert = false)"
      />
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.code="{ item }">
      {{ item.franchise.code }} - {{ item.code }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.company="{ item }">
      {{ item.franchise.code }} - {{ item.franchise.name }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.issuance_date="{ item }">
      {{ item.issuance_date | dateFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.value="{ item }">
      {{ getValueWithDiscount(item) | currencyEuaToBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.products_len="{ item }">
      {{ item.products.length }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.quantity="{ item }">
      {{ getQuantityProducts(item) }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status="{ item }">
      <v-chip dense label :color="getColor(item.status)" dark>
        {{ getLabel(item.status) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip
        v-if="
          item.status !== 'refused_supplier' &&
          item.status !== 'invoiced_supplier'
        "
        top
        color="blue darken-1"
      >
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-4"
            color="blue darken-1"
            @click="editItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-note-outline
          </v-icon>
        </template>
        <span>Gerenciar</span>
      </v-tooltip>
      <v-tooltip top color="success">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-btn :href="getUrlPrint(item)" target="_blank" icon color="pink">
            <v-icon color="green darken-1" v-bind="attrs" v-on="on">
              mdi-printer
            </v-icon>
          </v-btn>
        </template>
        <span>Imprimir</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <h4>Não existem pedidos com o filtro selecionado</h4>
    </template>
  </v-data-table>
</template>

<script>
import { URL } from "@/api/config";
import * as HTTP from "@/api/requests/base";
import { getStatusName } from "@/helpers/order_status";
import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    loading: false,
    orders: [],
    search: "",
    dialogDelete: false,
    listStatus: [
      { value: "validated_franchisor", text: "Aguardando Confirmação" },
      { value: "confirmed_supplier", text: "Confirmado pelo Fornecedor" },
      { value: "refused_supplier", text: "Recusado pelo Fornecedor" },
      { value: "invoiced_supplier", text: "Faturado pelo Fornecedor" },
    ],
    headers: [
      {
        text: "Pedido",
        align: "right",
        value: "code",
        width: 50,
      },
      { text: "Franqueado", value: "company", width: 300 },
      { text: "Produtos", value: "products_len", width: 80, align: "center" },
      { text: "Quantidade", value: "quantity", width: 80, align: "center" },
      { text: "Valor", value: "value", width: 100, align: "right" },
      { text: "Data", value: "issuance_date", width: 100 },
      { text: "Status", value: "status", width: 150 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    error: "",
    alertSuccess: "",
    valid: true,
    lazy: false,
    radioGroupDraft: 0,
    dialogRemoveOrder: false,
    item_delete: "",
    companySelected: "",
    dialogStatus: false,
    companySessionSelected: {
      id: "",
      name: "",
      code: "",
    },
    filter_status: ["validated_franchisor"],
    editedItem: {
      franchise: {},
    },
    showAlert: false,
    typeAlert: "success",
    alertMessage: "",
    file: null,
  }),
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    // dateFormatBr: function (value) {
    //   if (!value) return;
    //   let [date, hours] = value.split(" ");
    //   date = date.split("-").reverse().join("/");
    //   return `${date} ${hours}`;
    // },
  },
  created() {
    let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
    if (session) {
      session = JSON.parse(session);
      if (
        session.company_selected !== "" &&
        session.company_selected !== undefined
      ) {
        this.companySessionSelected = session.company_selected;
        this.companySelected = this.companySessionSelected.id;
      }
      this.initialize();
    } else {
      this.initialize();
    }
  },
  methods: {
    async initialize() {
      this.getOrdersProvider();
    },
    currencyBrToEua(value) {
      return value.toString().replace(/\./gi, "").replace(/,/gi, ".");
    },
    async getOrdersProvider() {
      this.orders = [];
      this.loading = true;
      try {
        const response = await fetch(
          `${URL}order/provider?provider_id=${this.companySelected}`
        );
        let data = await response.json();
        if (data.length > 0) {
          this.orders = data;
        }
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível carregar os pedidos, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    editOrder(id) {
      this.$router.push({ name: "CreateInvoice", params: { id: id } });
    },
    removeOrder(id) {
      this.item_delete = id;
      this.dialogRemoveOrder = true;
    },
    handleCancelRemoveOrder() {
      this.item_delete = "";
      this.dialogRemoveOrder = false;
    },
    deleteItemConfirm() {},
    closeDelete() {},
    getLabel(status) {
      if (status === "validated_franchisor") {
        return "Aguardando Confirmação";
      }
      return getStatusName(status);
    },
    getColor(status) {
      if (status === "validated_franchisor") {
        return "yellow darken-3";
      } else if (status === "confirmed_supplier") {
        return "green ligthen-2";
      } else if (status === "refused_supplier") {
        return "red ligthen-2";
      } else if (status === "invoiced_supplier") {
        return "blue ligthen-2";
      }
    },
    getQuantityProducts(item) {
      return item.products.reduce(
        (prev, curr) =>
          prev +
          curr.sizes.reduce(
            (sizePrev, currPrev) => sizePrev + parseInt(currPrev.quantity),
            0
          ),
        0
      );
    },
    filterStatusOrder(registers) {
      if (this.filter_status.length === 4) {
        return registers;
      } else {
        return registers.filter(
          (item) =>
            this.filter_status.find((i) => i === item.status) !== undefined
        );
      }
    },
    getUrlPrint(item) {
      return `${URL}order/print/${item.id}/true`;
    },
    getValueWithDiscount(item) {
      if (typeof item.products === "undefined") {
        return "";
      }
      let getDiscount = (product) => {
        return parseFloat((product.price * (item.discount / 100)).toFixed(2));
      };
      let getQuantity = (product) => {
        return product.sizes.reduce(
          (prev, curr) => prev + parseInt(curr.quantity),
          0
        );
      };
      let getTotal = (product) => {
        let qty = getQuantity(product);
        return (product.price - getDiscount(product)) * qty;
      };
      let total = item.products.reduce(
        (prev, curr) => prev + getTotal(curr),
        0
      );
      return total;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editedItem.value_note = "";
      this.editedItem.number_note = "";
      this.editedItem.reason_refused = "";
      this.showAlert = false;
      this.dialogStatus = true;
    },
    closeDialogStatus() {
      this.dialogStatus = false;
    },
    async saveOrderStatus() {
      let form = new FormData();

      if (this.editedItem.status === "invoiced_supplier") {
        if (this.editedItem.number_note === "") {
          alert("Preencha o número da nota");
          return true;
        }
        if (
          this.editedItem.value_note === "" ||
          this.editedItem.value_note == 0
        ) {
          alert("Preencha o valor da nota");
          return true;
        }
        form.append("number_note", this.editedItem.number_note);
        form.append("value_note", this.editedItem.value_note);
        if (this.file !== null) {
          form.append("attachment_note", this.file);
        }
      } else if (this.editedItem.status === "refused_supplier") {
        if (this.editedItem.reason_refused === "") {
          alert("Preencha o motivo da recusa");
          return true;
        }
        form.append("reason_refused", this.editedItem.reason_refused);
      }
      form.append("status", this.editedItem.status);
      form.append("_method", "PATCH");

      this.loadingSaveStatus = true;
      try {
        let res = await fetch(
          `${URL}order/${this.editedItem.id}/update-status`,
          {
            method: "POST",
            body: form,
          }
        );
        res = await res.json();
        console.log(res);
        this.alertMessage = "Pedido atualizado com sucesso";
        this.typeAlert = "success";
        this.showAlert = true;
        this.getOrdersProvider();
      } catch (error) {
        console.log(error);
        this.alertMessage =
          "Não foi possível atualizar o pedido, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loadingSaveStatus = false;
        this.dialogStatus = false;
      }
      console.log(this.editedItem);
    },
    onFilePicked(e) {
      this.file = e;
    },
  },
};
</script>

<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}

.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}

.image-clickable {
  cursor: pointer;
}

.cart-editing {
  background-color: #ffab00;
}

.v-text-field--outlined.border-color-field >>> fieldset {
  border-color: #666;
}
</style>
